<template>
  <div class="block block_wide">
    <div class="block__intro block__item">
      <div class="block__intro-item">
        <h2>Участники
          <sup class="color-muted"><b>{{ membersCount || '' }}</b></sup>
        </h2>
      </div>
    </div>
    <div class="block__body block__item block__item_sm" v-if="!isReady">
      <div class="loader m-0"></div>
    </div>
    <div class="block__item block__item_sm" v-show="isReady">
      <div class="block__body block__item block__item_sm" v-show="!isEmpty">
        <div class="block__intro-item">
          <div class="input">
            <div class="input__icons">
              <div class="input__icon">
                <icon icon-name="search"></icon>
              </div>
            </div>
            <input class="input__el"
                   v-model="params.search"
                   type="search"
                   placeholder="Найти участника...">
            <div class="input__border"></div>
            <div class="input__icons">
              <button class="input__icon input__icon_hover"
                      v-show="params.search"
                      @click.prevent="params.search = null">
                <icon icon-name="close-circle-s"></icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="block__item block__item_sm" v-show="isReady">
        <div class="block__body block__item block__item_sm"
             v-show="!isEmpty"
             style="position: relative">
          <div class="overlay overlay_light overlay_flex"
               v-show="isSearching && membersSearchCount"
               style="z-index: 2">
            <div class="overlay__content overlay__content_top">
              <div class="loader"></div>
            </div>
          </div>
          <section class="empty-state"
                   v-show="!membersSearchCount">
            <div class="loader m-0"
                 v-show="membersLoading">
            </div>
            <div class="section__group mt-0"
                 v-show="!membersLoading">
              <div class="section__item">Ничего не&nbsp;найдено</div>
            </div>
          </section>
          <div class="block__group"
               v-show="getAdmins.length">
            <div class="block__body-item">
              <div class="heading-line">
                <span class="heading-line__text">Администраторы</span>
              </div>
            </div>
            <div class="block__body-item"
                 v-for="item in getAdmins"
                 :key="item.id">
              <Member
                :userId="item.id"
                :name="item.fullName"
                :img="item.avatarSmallUrl"
                :imgSize="64"
              >
                <template v-slot:name="">
                  <span class="text-md">{{ item.fullName}}</span>
                </template>
                <template>
                  <div class="text-xs">{{ memberLocation(item.city, item.country) }}</div>
                  <div class="text-sm color-muted">
                    <b>В клубе с {{ $moment(item.processedDate).format('DD MMMM YYYY') }}</b>
                  </div>
                </template>
                <template
                  v-slot:actions="" v-if="isReady">
                  <button class="button button_secondary button_square"
                          :class="{ 'button_loading': getMemberStatus(item.id, 'excluding') }"
                          :disabled="getMemberStatus(item.id, 'excluding')"
                          :ref="item.id"
                  >
                    <span class="button__icon">
                      <icon icon-name="more-horizontal"></icon>
                    </span>
                    <span class="button__icon button__loading">
                      <icon icon-name='loading'></icon>
                    </span>
                  </button>
                  <Dropdown
                    :trigger="item.id"
                    placement="bottom-end"
                  >
                    <template slot="items">
                      <div class="dropdown__item">
                        <a class="dropdown__link"
                           href="#"
                           @click.prevent="exclude(item.id)">
                          <span class="dropdown__text">Исключить из клуба</span>
                        </a>
                      </div>
                    </template>
                  </Dropdown>
                </template>
              </Member>
            </div>
          </div>
          <div class="block__group"
               v-show="getNotAdmins.length">
            <div class="block__body-item">
              <div class="heading-line">
                <span class="heading-line__text">Недавно в&nbsp;клубе</span>
              </div>
            </div>
            <div class="block__body-item"
                 v-for="item in getNotAdmins"
                 :key="item.id"
            >
              <Member
                :userId="item.id"
                :name="item.fullName"
                :img="item.avatarSmallUrl"
                :imgSize="64"
              >
                <template v-slot:name="">
                  <span class="text-md">{{ item.fullName }}</span>
                </template>
                <template>
                  <div class="text-xs">{{ memberLocation(item.city, item.country) }}</div>
                  <div class="text-sm color-muted">
                    <b>В клубе с {{ $moment(item.processedDate).format('DD MMMM YYYY') }}</b>
                  </div>
                </template>
                <template
                  v-slot:actions="" v-if="isReady">
                  <button class="button button_secondary button_square"
                          :class="{ 'button_loading': getMemberStatus(item.id, 'excluding') }"
                          :disabled="getMemberStatus(item.id, 'excluding')"
                          :ref="item.id"
                  >
                    <span class="button__icon">
                      <icon icon-name="more-horizontal"></icon>
                    </span>
                    <span class="button__icon button__loading">
                      <icon icon-name='loading'></icon>
                    </span>
                  </button>
                  <Dropdown
                    :trigger="item.id"
                    placement="bottom-end"
                  >
                    <template slot="items">
                      <div class="dropdown__item">
                        <a class="dropdown__link"
                           v-if="item.email"
                           :href="`mailto:${item.email}`"
                        >
                          <span class="dropdown__text">Написать на почту</span>
                        </a>
                        <a class="dropdown__link"
                           href="#"
                           @click.prevent="exclude(item.id)">
                          <span class="dropdown__text">Исключить из клуба</span>
                        </a>
                      </div>
                      <div class="dropdown__item">
                        <a class="dropdown__link"
                           href="#"
                           @click.prevent="makeManager(item.id)"
                        >
                          <span class="dropdown__text">Назначить администратором</span>
                        </a>
                      </div>
                    </template>
                  </Dropdown>
                </template>
              </Member>
            </div>
          </div>
          <infinite-loading
            @infinite="infiniteLoader"
            :identifier="infiniteId"
          >
            <div class="loader" slot="spinner"></div>
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </div>
        <div class="block__item block__item_sm" v-show="isEmpty">
          <section class="empty-state">
            <div class="section__group mt-0">
              <div class="section__item">
                <img :src="$getTenantImg('noMembers')" alt=""/>
              </div>
              <div class="section__item">
                <div class="text-lg"><b>Станьте первым участником клуба</b></div>
                <div class="mt-8">Вступите в&nbsp;клуб, как участник, чтобы стать примером и&nbsp;вдохновить других присоединиться.</div>
              </div>
            </div>
            <div class="section__group">
              <div class="section__item">
                <button class="button button_primary button_lg"
                        :class="{ 'button_loading': isJoining }"
                        :disabled="isJoining"
                        @click.prevent="join"
                >
                  <span class="button__text">Вступить в клуб</span>
                  <span class="button__icon button__loading">
                    <icon icon-name="loading"></icon>
                  </span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import Member from '@/components/Member'
import { debounce } from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import managementService from '@/services/managementService'

export default {
  name: 'ManageMembers',
  components: {
    Member,
    InfiniteLoading
  },
  data () {
    return {
      isSearching: false,
      params: {
        offset: 0,
        take: 12,
        search: null
      },
      infiniteId: +new Date(),
      refLink: window.location.origin + '/club/' + this.$route.params.id || this.$getTenantIdClub(),
      isJoining: false
    }
  },
  computed: {
    ...mapState('club', ['clubCode', 'clubInfo']),
    ...mapState('clubManagement', ['members', 'membersCount', 'membersSearchCount', 'membersLoading', 'membersStatus']),
    ...mapGetters('clubManagement', ['getAdmins', 'getNotAdmins']),
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    },
    isReady () {
      return this.clubInfo && this.members
    },
    isEmpty () {
      return this.isReady && !this.membersCount
    }
  },
  methods: {
    ...mapActions('club', ['joinClub']),
    ...mapActions('alerts', ['addSomethingWrongAlert', 'addSuccessAlert']),
    ...mapActions('clubManagement', ['getMembers', 'excludeMember']),
    ...mapMutations('clubManagement', ['clearMembers']),
    ...mapMutations('club', ['triggerInfoUpdate', 'triggerMembersUpdate']),
    memberLocation (city, country) {
      if (!city) {
        return null
      }
      let result = city
      if (country) {
        result += ', ' + country
      }
      return result
    },
    search () {
      if (this.prevSearch === this.params.search) {
        return
      }
      this.prevSearch = this.params.search
      this.params.offset = 0
      this.isSearching = true
      this.loadItems()
    },
    infiniteLoader ($state) {
      this.infiniteState = $state
      this.params.offset = this.members ? this.members.length : 0
      this.loadItems()
    },
    loadItems () {
      this.getMembers({
        clubCode: this.idClub,
        searchString: this.params.search,
        offset: this.params.offset,
        take: this.params.take
      })
    },
    exclude (userId) {
      this.excludeMember({
        userId,
        clubCode: this.idClub
      })
    },
    getMemberStatus (id, status) {
      return this.membersStatus[id] && this.membersStatus[id][status]
    },
    join () {
      this.isJoining = true
      this.joinClub({
        clubId: this.clubInfo.id
      })
        .then((response) => {
          this.isJoining = false
          if (response.data.isSuccess) {
            this.addSuccessAlert('Вы вступили в клуб')
            this.loadItems()
            this.triggerInfoUpdate()
            this.triggerMembersUpdate()
            return
          }
          this.addSomethingWrongAlert(response.data.errorMessage)
        })
        .catch(() => {
          this.isJoining = false
          this.addSomethingWrongAlert()
        })
    },
    makeManager (userId) {
      this.$root.confirmDialog(
        {
          title: 'Вы уверены, что хотите передать права администратора клуба?',
          confirmText: 'Подтвердить'
        },
        () => {
          managementService.changeManager({
            clubCode: this.idClub,
            userId
          })
            .then((response) => {
              if (response.data.isSuccess) {
                this.$router.replace({
                  name: 'Club',
                  params: {
                    id: this.$route.params.id || this.$getTenantIdClub()
                  }
                })
              } else {
                this.addSomethingWrongAlert(response.data.errorMessage)
              }
            })
            .catch(() => {
              this.addSomethingWrongAlert()
            })
        }
      )
    }
  },
  watch: {
    'params.search' () {
      this.debouncedSearch()
    },
    membersLoading (val) {
      if (val) {
        return
      }
      this.isSearching = false

      if (this.members) {
        this.infiniteState && this.infiniteState.loaded()
        if (this.members.length === this.membersSearchCount) {
          this.infiniteState && this.infiniteState.complete()
        } else {
          this.infiniteId += 1
        }
      }
    }
  },
  created () {
    this.debouncedSearch = debounce(this.search, 500)
    this.clearMembers()
    this.loadItems()
  }
}
</script>

<style scoped>
</style>
